export enum TypeMenuItem {
    EXTERNAL_APP,
    INTERNAL_APP
}
